import { render, staticRenderFns } from "./emptyPage.vue?vue&type=template&id=04e69b87"
import script from "./emptyPage.vue?vue&type=script&lang=js"
export * from "./emptyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports